<template>
  <v-dialog
    v-model="showDialog"
    persistent
    max-width="500px"
  >
    <v-card>
      <v-card-title class="pb-0 subtitle-1">
        {{ title }}
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          @keyup.enter.native="actionClick()"
        >
          <v-text-field
            :value="firstPartyName"
            label="From"
            disabled
          />
          <v-text-field
            :value="counterpartyName"
            label="To"
            disabled
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          small
          text
          @click.stop="close()"
        >
          Cancel
        </v-btn>
        <v-btn
          small
          color="primary"
          @click.stop="send()"
        >
          Send
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { getCounterPartyNames } from '@/dataAccess/parties'

export default {
  name: 'SendActionDialog',
  props: {
    document: { type: Object, required: true },
    showDialog: { type: Boolean, default: false }
  },
  computed: {
    title() {
      return `Send - ${this.document.name}`
    },
    firstPartyName() {
      return this.document.firstParty.name
    },
    counterpartyName() {
      return getCounterPartyNames(this.document)
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    async send() {
      const { name } = this.document
      this.$handlingError(`Error sending document ${name}. Ensure you have sufficient document credits.`, async () => {
        this.sendDialog = false
        await this.$api.sendForSignature(this.document)
      })
      this.close()
    }
  }
}
</script>

<style>
  .select-tall {
    max-height: 300px !important;
  }

  .dense-list ul {
    padding: 0;
  }

  .dense-list li.subheader {
    height: 40px;
  }
</style>
